// ---------------------------------------------- modules import
import { IOrderedPinnedPost } from "../firebase/common";
import { MenuIndex } from "../helpers/permissionHelper";
import { newTags } from "../helpers/tagHelper";
import firebase from "../../config/fbInit";

export interface IAuthor {
  email: string;
  name: string;
}

export interface IReader {
  id: string;
  name: string;
  email: string;
}

export interface IPinnedPost extends IOrderedPinnedPost {
  [key: string]: any;
}

const newAuthor = (): IAuthor => ({
  email: "",
  name: ""
});

export const newPinnedPost = (author?: IAuthor): IOrderedPinnedPost => ({
  id: "",
  title: "",
  data: {
    time: 0,
    version: "0",
    blocks: []
  },
  category: "",
  tags: newTags(),
  author: author ? author : newAuthor(),
  createdAt: firebase.firestore.Timestamp.now(),
  lastModified: firebase.firestore.Timestamp.now(),
  pinnedAt: firebase.firestore.Timestamp.now(),
  indexOrigin: MenuIndex.GeneralPost,
  readers: []
});

// ---------------------------------------------- state interface
export interface IPinnedPostState {
  loading: boolean;
  error: string | null;
}

// ---------------------------------------------- action type enum
export enum PinnedPostActionType {
  UPDATE_PINNEDPOST_BEGIN = "UPDATE_PINNEDPOST_BEGIN",
  UPDATE_PINNEDPOST_SUCCESS = "UPDATE_PINNEDPOST_SUCCESS",
  UPDATE_PINNEDPOST_ERROR = "UPDATE_PINNEDPOST_ERROR",
  UNPIN_PINNEDPOST_BEGIN = "UNPIN_PINNEDPOST_BEGIN",
  UNPIN_PINNEDPOST_SUCCESS = "UNPIN_PINNEDPOST_SUCCESS",
  UNPIN_PINNEDPOST_ERROR = "UNPIN_PINNEDPOST_ERROR"
}

// ---------------------------------------------- action interfaces
interface IUpdateBegin {
  type: typeof PinnedPostActionType.UPDATE_PINNEDPOST_BEGIN;
}

interface IUpdateSuccess {
  type: typeof PinnedPostActionType.UPDATE_PINNEDPOST_SUCCESS;
}

interface IUpdateError {
  type: typeof PinnedPostActionType.UPDATE_PINNEDPOST_ERROR;
  payload: {
    error: string;
  };
}

interface IUnpinBegin {
  type: typeof PinnedPostActionType.UNPIN_PINNEDPOST_BEGIN;
}

interface IUnpinSuccess {
  type: typeof PinnedPostActionType.UNPIN_PINNEDPOST_SUCCESS;
}

interface IUnpinError {
  type: typeof PinnedPostActionType.UNPIN_PINNEDPOST_ERROR;
  payload: {
    error: string;
  };
}

// ---------------------------------------------- exported action type
export type PinnedPostAction =
  | IUpdateBegin
  | IUpdateSuccess
  | IUpdateError
  | IUnpinBegin
  | IUnpinSuccess
  | IUnpinError;
